export const environment = {
  production: false,
  app_name: 'CognitoX',
  app_url: 'https://dash-dev.cognitox.org',
  base_url: 'https://dev.cognitox.org',
  // base_url: 'http://localhost:8080',
  billing_url: 'https://billing-dev.cognitox.org',
  // billing_url: 'http://localhost:8082',
  file_service_url: 'https://files-dev.cognitox.org',
  api_version: '/api/v1',
  client_id: 'client_id',
  client_secret: 'client_secret',
  resizeRedirectionEnabled: true,
  redirectionWindowWidth: 800,
  redirectUrl: 'https://cognitox.org',
  realm_admin_url: "https://auth.cognitox.org/admin/cognito-prod/console",
  realm_url: "https://auth.cognitox.org/realms/cognito-prod",
  auth_client_id: 'frontend-dashboard',
  auth_scopes: 'openid email profile organization',
  logo_uri: 'assets/apanel/images/logos/logo.svg',
  logo_wide_uri: 'assets/apanel/images/logos/logo-wide.svg',
};
